import PropTypes from "prop-types";

function DashboardProgressCard({ type, leftValue, rightValue, progressAmount }) {
  if (type === "primary") {
    return (
      <div className="card card-tertiary card-progress">
        <div className="card-progress-bar bg-primary" style={{ width: progressAmount }} />
        <div className="card-progress-value" dangerouslySetInnerHTML={{ __html: leftValue }} />
        <div className="card-progress-value" dangerouslySetInnerHTML={{ __html: rightValue }} />
      </div>
    );
  }

  return (
    <div className="card card-primary card-progress">
      <div className="card-progress-bar bg-tertiary" style={{ width: progressAmount }} />
      <div className="card-progress-value" dangerouslySetInnerHTML={{ __html: leftValue }} />
      <div className="card-progress-value" dangerouslySetInnerHTML={{ __html: rightValue }} />
    </div>
  );
}

DashboardProgressCard.propTypes = {
  type: PropTypes.string,
  leftValue: PropTypes.string,
  rightValue: PropTypes.string,
  progressAmount: PropTypes.string,
};

export default DashboardProgressCard;
